import useModalStore from '@/stores/modal.store';
import { ModalType } from '@/types/stores/modal/modal-type.enum';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import ModalBase from './ModalBase';
import OrderValidatingModal from './OrderValidatingModal';
import OrderValidationFailedModal from './OrderValidationFailedModal';
import PaymentPendingModal from './PaymentPendingModal';
import PaymentFailedModal from './PaymentFailedModal';
import OrderConfirmationFailedModal from './OrderConfimationFailedModal';
import OrderConfirmingModal from './OrderConfirmingModal';

export default function ModalRoot() {
  const type = useModalStore((state) => state.type);
  const props = useModalStore((state) => state.props);
  const close = useModalStore((state) => state.close);

  const MODAL_COMPONENTS: Record<ModalType, React.FC<any>> = {
    [ModalType.OrderValidating]: OrderValidatingModal,
    [ModalType.OrderValidationFailed]: OrderValidationFailedModal,
    [ModalType.PaymentPending]: PaymentPendingModal,
    [ModalType.PaymentFailed]: PaymentFailedModal,
    [ModalType.OrderConfirmationFailed]: OrderConfirmationFailedModal,
    [ModalType.OrderConfirming]: OrderConfirmingModal,
  };

  if (!type) return null;

  const ModalComponent = MODAL_COMPONENTS[type];

  return ReactDOM.createPortal(
    <ModalBase isOpen={Boolean(ModalComponent)} close={close}>
      <ModalComponent {...props} />
    </ModalBase>,
    document.body,
  );
}
